import type { App } from 'vue'
import Vant from 'vant'
import VxeUIBase from 'vxe-pc-ui'
import VxeUITable, { VxeUI } from 'vxe-table'
import 'vant/lib/index.css'
import '@vant/touch-emulator'

import 'vxe-pc-ui/es/style.css'
import 'vxe-table/es/style.css'

VxeUI.setConfig({
  zIndex: 0,
  table: {
    headerCellConfig: {
      height: 15,
    },
  },
})

function install(app: App) {
  app.use(Vant).use(VxeUIBase).use(VxeUITable)
}

export default { install }
